<template>
  <div>
    <div class="container">
      <div class="service">
        <p class="title">请选择要租摆的墓</p>
        <div>
          <div>
            <van-field
              required
              v-model="formData.bianhao"
              label="墓编号"
              placeholder="编号 或 **排**号"
            />
          </div>
        </div>
      </div>
      <div class="h10"></div>
      <div class="service">
        <p class="title">预约信息</p>
        <van-cell required title="祭扫日期" :value="formData.date" @click="show = true" />
        <i class="van-icon van-icon-arrow van-cell__right-icon jiantou"></i>
        <van-calendar v-model="show" @confirm="onConfirm" />
        <!---->
        <!---->
      </div>

      <div class="h10"></div>
      <div class="orderinfo">
        <span class="order">盆花清单</span>
        <!---->
        <img src="" class="line1" />
        <div class="shop">
          <img src="../../assets/search1.jpg" class="pic2" />
          <div class="info">
            <span class="name">陶瓷盆花(1年)</span>
            <br />
            <br />
            <span class="size">陶瓷盆花</span>
            <br />
            <span class="money">￥399</span>
            <span class="num">×2</span>
          </div>
          <img src="" class="line" />
        </div>
        <div class="sum">
          <span class="ctext">总计：</span>
          <span class="money">￥798</span>
        </div>
      </div>
      <div class="h10"></div>
      <div class="service">
        <p class="title">备注</p>
        <textarea rows="4" placeholder="备注" class="textarea"></textarea>
      </div>
      <!---->
    </div>
    <div class="clear-foot"></div>
    <div class="button">
      <span class="text">需要支付 :</span>
      <span class="money">￥798</span>
      <div>创建订单</div>
    </div>
    <div data-v-a9eb2a58 class>
      <div data-v-a9eb2a58 class="success">
        <p data-v-a9eb2a58 class="title">预约提交成功</p>
        <span data-v-a9eb2a58 class="text">
          您已成功提交预订
          <br />请在我的订单中查看预约反馈
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'penhuazubaiCart',
  data() {
    return {
      formData: {
        mobile: '',
        tongxing: '',
        xingming: '',
        shenfenzheng: '',
        date: '',
      },
      saveFlag: false,
      show: false,

      // 校验手机号码
      telRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
        {
          // 自定义校验规则
          validator: value => {
            return /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/.test(
              value
            )
          },

          trigger: 'onBlur',
        },
      ],

      tongxingRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],

      xingmingRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],

      shenfenzhengRules: [
        {
          required: true,

          trigger: 'onBlur',
        },
      ],
    }
  },
  computed: {},
  created() {},
  methods: {
    formatDate(date) {
      console.log(date)
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    onConfirm(date) {
      this.show = false
      this.formData.date = this.formatDate(date)
    },
  },
  watch: {},
}
</script>
<style>
.van-field__control {
  text-align: right;
}
.jiantou {
  position: absolute;
  right: 2rem;
  top: 16.3rem;
}
.container {
  padding: 1rem;
  font-size: 1.6rem;
}
.service {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.service .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}

.service .mint-cell:last-child {
  background: none;
}

.service .mint-cell:last-child {
  background: none;
}

.service .mint-cell:last-child {
  background: none;
}
.mint-cell:last-child {
  background-image: linear-gradient(0deg, #d9d9d9, #d9d9d9 50%, transparent 0);
  background-size: 100% 1px;
  background-repeat: no-repeat;
  background-position: bottom;
}
.mint-field {
  display: -ms-flexbox;
  display: flex;
}
.mint-cell {
  background-color: #fff;
  box-sizing: border-box;
  color: inherit;
  min-height: 48px;
  display: block;
  overflow: hidden;
  position: relative;
  text-decoration: none;
}
.h10 {
  width: 100%;
  height: 1rem;
}
.service .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.orderinfo {
  background-color: #fff;
  padding-left: 1.5rem;
  padding-top: 1.5rem;
}
.orderinfo .order {
  font-size: 1.6rem;
}
.orderinfo .line1 {
  position: relative;
  top: 0.5rem;
}
.orderinfo .shop {
  height: 9.1rem;
  margin-top: 1.2rem;
  margin-bottom: 1.5rem;
}
.orderinfo .shop .pic2 {
  width: 8rem;
  height: 8rem;
}
.orderinfo .shop .info {
  width: 65%;
  height: 7.6rem;
  position: relative;
  left: 9rem;
  top: -8.2rem;
}
.orderinfo .shop .info .name {
  font-size: 1.4rem;
}
.orderinfo .shop .info .size {
  color: #999;
  font-size: 1.2rem;
}
.orderinfo .shop .info .money {
  color: #15a892;
  font-size: 1.6rem;
  line-height: 3.5rem;
}
.orderinfo .shop .info .num {
  float: right;
  font-size: 1.4rem;
  position: relative;
  right: 1rem;
  top: 0.8rem;
}
.orderinfo .line {
  position: relative;
  top: -7.5rem;
}

.line {
  width: 100%;
  border-bottom: 1px solid #eee;
}
.orderinfo .sum {
  font-size: 1.4rem;
  padding-right: 2rem;
  text-align: right;
}

.sum {
  padding-bottom: 1.5rem;
  padding-top: 1rem;
}
.orderinfo .sum .ctext {
  position: relative;
}

.orderinfo .sum span {
  position: relative;
}
.orderinfo .sum .money {
  color: #15a892;
}

.orderinfo .sum span {
  position: relative;
}
.service .title {
  padding: 1.3rem 0;
  line-height: 2rem;
}
.service .textarea {
  width: 100%;
  font-size: 1.4rem;
  border: 1px solid #eee;
  padding: 0.5rem;
  margin-bottom: 1rem;
  display: inline-block;
  line-height: 2rem;
  height: 9rem;
  box-sizing: border-box;
}
.clear-foot {
  clear: both;
  height: 5rem;
}
.button {
  width: 100%;
  height: 4.9rem;
  background-color: #fff;
  position: fixed;
  bottom: 0;
}
.button .text {
  margin-left: 2rem;
  font-size: 1.4rem;
  position: relative;
  left: 8rem;
}

.button .money {
  color: #15a892;
  font-size: 1.6rem;
  position: relative;
  left: 8rem;
}

.button .money,
.button .text {
  padding-top: 1.4rem;
  display: inline-block;
}
.button div {
  width: 30%;
  height: 4.9rem;
  background-color: #15a892;
  text-align: center;
  font-size: 1.4rem;
  color: #fff;
  float: right;
  padding-top: 1.4rem;
}
</style>
